export const ANNOUNCEMENT_TYPES = {
  ANNOUNCEMENT_HOME_PAGE: 'HPNA',
  ANNOUNCEMENT_PL: 'PLNA',
  ANNOUNCEMENT_CL: 'CLNA',
  ALERT_URGENT: 'PLYB',
  ALERT_REGULAR: 'CLYB',
};

export const MAILING_AND_CONTACT_INFORMATION_LINK = 'https://brandfolder.com/s/twfs559v4pc87svjw2xbm';

export const CUSTOMER_SERVICES_OVERVIEW_LINK = 'https://brandfolder.com/s/vvcft4msqzjfvcwz3gcgnvbg';

export const CUSTOMER_SERVICES_PHONE_QUICK_REFERENCE_LINK = 'https://brandfolder.com/s/xgnn4v9m7qf3t3jfhrccjt57';

export const ELECTRONIC_COMMISSION_AGENCY_SWEEP_LINK = 'https://brandfolder.com/s/cmskmvmnf8bccvfcsq9gxvc3';

export const QUALTRICS_SURVEY_LINK = 'https://survey.az1.qualtrics.com/jfe/form/SV_9U2168Iog0W9yrs';

export const RELATE_LINK = 'http://relate.amfam.com/';

export const SOURCE_SYSTEM_CLMSS = ['msa_insurity_cl_auto', 'MSA_WORKERS_COMP', 'msa_bop'];
